import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Api from '../../../Auth/Api';
import AddCursoModal from '../Modals/AddCursoModal';

const CursosManager = ({ token, nivel }) => {
    // Estados para gestão de cursos
    const [showModalAddCurso, setShowModalAddCurso] = useState(false);
    const [cursoAddFile, setCursoAddFile] = useState(false);
    const [uploadCursoProgress, setUploadCursoProgress] = useState(0);
    const [dataCursos, setDataCursos] = useState([]);
    
    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm();

    // Efeito para carregar a lista de cursos
    useEffect(() => {
        async function fetchCursos() {
            try {
                const response = await Api.get(`api/listar-cursos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataCursos(response.data);
            } catch (error) {
                console.error("Erro ao carregar cursos:", error);
            }
        }
        fetchCursos();
    }, [token]);

    const onSubmitAddCurso = async (data) => {
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        try {
            const response = await Api.post("/api/novo-curso", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    setUploadCursoProgress(percentCompleted + "%")
                    if (percentCompleted === 100) {
                        setTimeout(() => {
                            setUploadCursoProgress('Aguarde... finalizando...')
                        }, 1000)
                    }
                }
            });
            
            // Após adicionar um curso, atualiza a lista de cursos
            const responseUpdate = await Api.get(`api/listar-cursos`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setDataCursos(responseUpdate.data);
            
            reset();
            setCursoAddFile(false);
            setUploadCursoProgress(0);
            setShowModalAddCurso(false);
            
            return {
                success: true,
                message: response.data.message
            };
        } catch (error) {
            console.error("Erro ao criar novo curso:", error);
            
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar curso"
            };
        }
    };

    const openAddCursoModal = () => {
        setShowModalAddCurso(true);
        setUploadCursoProgress(0);
        reset();
    };

    // Estilos para os campos Select
    const customStyles = {
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#233734",
            "&:hover": {
                borderColor: "#3a6883"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
        }),
        input: (base) => ({
            ...base,
            color: '#adb5bd',
            height: "52px",
            margin: '0px',
            padding: '0px !important',
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };

    return {
        dataCursos,
        openAddCursoModal,
        showModalAddCurso,
        setShowModalAddCurso,
        cursoAddFile,
        setCursoAddFile,
        uploadCursoProgress,
        setUploadCursoProgress,
        onSubmitAddCurso,
        customStyles,
        renderModal: (topicosManager) => (
            <AddCursoModal
                showModalAddCurso={showModalAddCurso}
                setShowModalAddCurso={setShowModalAddCurso}
                setShowModalAddTopico={topicosManager.setShowModalAddTopico}
                dataTopicos={topicosManager.dataTopicos}
                setIdTopico={topicosManager.setIdTopico}
                idTopico={topicosManager.idTopico}
                customStyles={customStyles}
                cursoAddFile={cursoAddFile}
                setCursoAddFile={setCursoAddFile}
                uploadCursoProgress={uploadCursoProgress}
                register={register}
                errors={errors}
                control={control}
                handleSubmit={handleSubmit}
                onSubmitAddCurso={onSubmitAddCurso}
            />
        )
    };
};

export default CursosManager; 